// extracted by mini-css-extract-plugin
module.exports = {"postMeta":"post-module--post-meta--1ci95","postContent":"post-module--post-content--3nfbA"};